<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card title="Podsumowanie" class="title-inline">
          <b-card-text>
            <b-row v-if="discount && totalOrderNet == 0">
              <div class="px-3 mb-3">
                Dziękujemy za złożenie zamówienia. <br />
                Korzystasz z promocji {{ discount }}. Zaakceptuj Regulamin
                zakupu i Politykę Prywatności i wyślij zamówienie.
              </div>
            </b-row>
            <b-row v-else>
              <b-col lg="12">
                <b-table
                  :items="allProductsFiltered"
                  :fields="fields"
                  responsive="md"
                  foot-clone
                >
                  <template #head(net) class="text-right">
                    <div class="text-right mr-5">Netto</div>
                  </template>
                  <template #head(vat) class="text-right">
                    <div class="text-right">VAT</div>
                  </template>
                  <template #head(gross) class="text-right">
                    <div class="text-right">Brutto</div>
                  </template>
                  <template #cell(label)="data" class="">
                    <div class="mr-5" v-html="data.item.label"></div>
                  </template>
                  <template #cell(net)="data" class="text-right">
                    <div class="text-right mr-5">
                      {{ commaFormat(data.item.net) }} zł
                    </div>
                  </template>
                  <template #cell(vat)="data">
                    <div class="text-right">{{ data.item.vat }} %</div>
                  </template>
                  <template #cell(gross)="data">
                    <div class="text-right">
                      {{ commaFormat(data.item.gross) }} zł
                    </div>
                  </template>
                  <template #foot(label)>
                    <div
                      v-if="
                        discountRecommendation ||
                        discountCloudHalfYear ||
                        discountCloudFullYear ||
                        seasonalDiscount ||
                        discount ||
                        discounts.length > 0
                      "
                      class="text-danger"
                      v-html="discountText"
                    ></div>
                    <br
                      v-if="
                        discountRecommendation ||
                        discountCloudHalfYear ||
                        discountCloudFullYear
                      "
                    />
                    <p class="mb-0 mt-3"></p>
                  </template>
                  <template #foot(quantity)>
                    <br
                      v-if="
                        discountRecommendation ||
                        discountCloudHalfYear ||
                        discountCloudFullYear
                      "
                      class="mt-1"
                    />
                    <div class="mb-0 mt-3">Razem do zapłaty:</div>
                  </template>
                  <template #foot(net)>
                    <div
                      v-if="discountRecommendation"
                      class="text-danger text-right mr-5"
                    >
                      -{{ commaFormat(discountRecommendation) }} zł
                    </div>
                    <br
                      v-if="
                        discountRecommendation ||
                        discountCloudHalfYear ||
                        discountCloudFullYear
                      "
                    />
                    <div
                      class="text-right mt-3 mb-0 mr-5"
                      :class="{
                        'mt-3': !(
                          discountRecommendation ||
                          discountCloudHalfYear ||
                          discountCloudFullYear
                        ),
                      }"
                    >
                      {{ commaFormat(totalOrderNet) }} zł
                    </div>
                  </template>
                  <template #foot(vat)>
                    <br
                      v-if="
                        discountRecommendation ||
                        discountCloudHalfYear ||
                        discountCloudFullYear
                      "
                    />
                    <div class="text-right mb-0 mt-3">23 %</div>
                  </template>
                  <template #foot(gross)>
                    <br
                      v-if="
                        discountRecommendation ||
                        discountCloudHalfYear ||
                        discountCloudFullYear
                      "
                    />
                    <div class="text-right mb-0 mt-3">
                      {{ commaFormat(totalOrderGross) }} zł
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <hr class="mt-0" />
            <b-row>
              <div class="px-3">
                <span
                  @click="selectPolicy(policy === false)"
                  class="mr-1 checkboxPointer"
                >
                  <img
                    v-if="policy === true"
                    :src="styles.checkbox_new"
                    alt="check"
                    class="mb-1"
                  />
                  <input v-else type="checkbox" />
                  Przeczytaj i zaakceptuj
                </span>
                <span>
                  <a
                    class="text-underline text-italic"
                    :href="regulations"
                    rel="external"
                    title="Regulamin"
                    target="_blank"
                    >Regulamin zakupu</a
                  >
                  <span>,</span>
                  <a
                    class="text-underline text-italic"
                    :href="baseurl + 'REGULAMIN-SERWISU-SKP-MOJE-KONTO.pdf'"
                    rel="external"
                    title="Regulamin"
                    target="_blank"
                    >Regulamin MK</a
                  >

                  <span v-if="discountBlackWeek">
                    ,
                    <a
                      :href="
                        baseurl +
                        (this.currentOs
                          ? 'SKP-REGULAMIN-PROMOCJI-BLACK-MONTH.pdf'
                          : 'SKP-REGULAMIN-PROMOCJI-BLACK_MONTH')
                      "
                      title="Regulamin promocji"
                      target="_blank"
                      >Regulamin Promocji</a
                    >
                  </span>

                  <span v-if="cartCloud && cartCloud.length > 0">, </span>
                  <span
                    v-if="
                      isAccountant &&
                      program === 'skp' &&
                      cartCloud &&
                      cartCloud.length > 0
                    "
                  >
                    <a
                      :href="
                        baseurl +
                        'REGULAMIN-KORZYSTANIA-Z-KONTA-SKP-BIURO-W-CHMURZE.pdf'
                      "
                      title="Regulamin korzystania z Usługi SKP24 Connect Biuro"
                      target="_blank"
                      >Regulamin korzystania z Usługi SKP24 Connect Biuro</a
                    ></span
                  >

                  <span
                    v-if="
                      !isAccountant &&
                      program === 'skp' &&
                      cartCloud &&
                      cartCloud.length > 0
                    "
                  >
                    <a
                      :href="
                        baseurl +
                        'REGULAMIN-KORZYSTANIA-Z-KONTA-SKP-FIRMA-W-CHMURZE.pdf'
                      "
                      title="Regulamin korzystania z Usługi SKP24 Connect Firma"
                      target="_blank"
                      >Regulamin korzystania z Usługi SKP24 Connect Firma</a
                    ></span
                  >

                  <span
                    v-if="
                      program === 'sam' && cartCloud && cartCloud.length > 0
                    "
                  >
                    <a
                      :href="
                        baseurl +
                        'REGULAMIN-KORZYSTANIA-Z-KONTA-SAM-FIRMA-W-CHMURZE.pdf'
                      "
                      title="Regulamin korzystania z Usługi SAM® Firma w Chmurze"
                      target="_blank"
                      >Regulamin korzystania z Usługi SAM® Firma w Chmurze</a
                    >
                  </span>

                  <span v-if="!currentOs"> oraz </span>
                  <span v-if="!currentOs">
                    <a
                      :href="osRegulations"
                      title="Regulamin Opieki Serwisowej"
                      target="_blank"
                      >Regulamin Opieki Serwisowej</a
                    >
                  </span>
                  <span v-if="osDiscount25PromotionSKP">
                    i
                    <a
                      v-if="osDiscount25PromotionSKP"
                      :href="osDiscount25PromotionSKP"
                      title="Regulamin Opieki Serwisowej"
                      target="_blank"
                      >Regulamin Promocji</a
                    >
                  </span>
                  <span v-if="osDiscount25PromotionSAM">
                    i
                    <a
                      v-if="osDiscount25PromotionSAM"
                      :href="osDiscount25PromotionSAM"
                      title="Regulamin Opieki Serwisowej"
                      target="_blank"
                      >Regulamin Promocji</a
                    >
                  </span>

                  <span v-if="seasonalDiscount === 604"> oraz </span>
                  <a
                    v-if="seasonalDiscount === 604"
                    :href="ossPromotion"
                    title="Regulamin Promocji"
                    target="_blank"
                    >Regulamin Promocji</a
                  >
                  <span v-if="seasonalDiscount === 610 && false"> oraz </span>
                  <a
                    v-if="seasonalDiscount === 610 && false"
                    href=""
                    title="Regulamin Promocji"
                    target="_blank"
                    >Regulamin Promocji</a
                  >
                  <span v-if="changeSKP"> oraz </span>
                  <a
                    v-if="changeSKP"
                    :href="
                      baseurl +
                      'SAM-REGULAMIN-PROMOCJI-50-PROCENT-WRAZ-Z-PRZEJSCIEM-NA-SKP-ZA-0PLN-OS.pdf'
                    "
                    title="Regulamin Promocji"
                    target="_blank"
                    >Regulamin Promocji</a
                  >.
                </span>
              </div>
            </b-row>
            <b-row>
              <div class="accordion order-card" role="tablist" id="gdpr">
                <b-card no-body class="mb-2 mx-3 noborder-card">
                  <b-card-header
                    header-tag="header"
                    class="p-1 small ml-2"
                    role="tab"
                  >
                    Administratorem Twoich danych osobowych jest FORMSOFT sp. z
                    ograniczoną odpowiedzialnością
                    <span v-b-toggle.gdpr>
                      <span class="when-closed px-2">
                        <i class="fas fa-chevron-down"></i
                      ></span>
                      <span class="when-open px-2"
                        ><i class="fas fa-chevron-up when-open"></i
                      ></span>
                    </span>
                  </b-card-header>
                  <b-collapse id="gdpr" accordion="gdpr" role="tabpanel">
                    <b-card-body>
                      <b-card-text class="px-3 small">
                        <ol>
                          <li>
                            Podanie danych jest dobrowolne, ale konieczne w celu
                            kontaktu, założenia konta, obsługi sprzedażowej i
                            posprzedażowej zamówień. Nie przetwarzamy Twoich
                            danych wrażliwych.
                          </li>
                          <li>
                            Masz prawo dostępu, poprawiania, modyfikacji,
                            aktualizacji, sprostowania, żądania przeniesienia
                            lub usunięcia danych, wycofania zgody na
                            przetwarzanie danych w całości lub w oznaczonym
                            celu. W tym celu prosimy o kontakt pod adresem
                            <a href="mailto:rodo@formsoft.pl" target="_blank"
                              >rodo@formsoft.pl</a
                            >.
                          </li>
                          <li>
                            Ponadto masz prawo zgłoszenia sprzeciwu co do
                            przetwarzania przez nas Twoich danych do Urzędu
                            Ochrony Danych Osobowych (UODO).
                          </li>
                          <li>
                            Szczegółowe informacje dotyczące przetwarzania
                            Twoich danych znajdziesz w naszej
                            <a
                              :href="
                                baseurl + 'POLITYKA-PRYWATNOSCI-FORMSOFT.pdf'
                              "
                              target="_blank"
                              >Polityce prywatności</a
                            >.
                          </li>
                        </ol>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-row>
            <b-row
              ><p v-if="errors.length"></p>
              <ul>
                <li v-for="error in errors" :key="error" class="text-danger">
                  {{ error }}
                </li>
              </ul>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <p class="bot-link" @click="runChat">
        <strong>Potrzebujesz szybkiej pomocy?<br /></strong>
        Zapytaj Wirtualnego Asystenta SKP<sup>®</sup> >
      </p>
      <b-button
        variant="secondary"
        class="mx-3 ml-auto mb-2 btn-color"
        @click="backStep"
        >Wstecz
      </b-button>
      <b-button
        v-if="totalOrderNet == 0"
        variant="success"
        class="mx-3 mb-2 btn-accept-color"
        @click="forwardStep"
        >Wyślij zamówienie
      </b-button>
      <b-button
        v-else
        variant="success"
        class="mx-3 mb-2 btn-accept-color"
        @click="forwardStep"
        >Zamawiam z obowiązkiem zapłaty
      </b-button>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helper from './config/helperData';
import axios from 'axios';

export default {
  name: 'OrderSummary',
  props: {
    cloudOptions: {},
    cloudNeverHave: { type: Boolean, default: false },
    isDiscount622_623: { type: Boolean, default: false },
    isDiscount656_657: { type: Boolean, default: false },
    isAccountant: { type: Boolean, default: false },
    skpCompanyAdd: { type: Boolean, default: false },
    skpAccountantAdd: { type: Boolean, default: false },
    program: {},
    styles: {},
    cloudDiscount: { default: false },
  },
  data() {
    return {
      fields: [
        { key: 'label', label: 'Produkt' },
        { key: 'quantity', label: 'Ilość' },
        { key: 'net', label: 'Netto' },
        { key: 'vat', label: 'VAT' },
        { key: 'gross', label: 'Brutto' },
      ],
      errors: [],
      skpAdd: null,
      year: process.env.MIX_AKTU_YEAR,
      changeSKP: false,
      monthEnding: process.env.MIX_MONTH_ENDING,
    };
  },
  created() {
    this.$store.dispatch('auth/me');
    this.productSummary();
  },
  computed: {
    ...mapGetters({
      storeVersion: 'order/version',
      storePayment: 'order/payment',
      storeDelivery: 'order/delivery',
      cartProducts: 'order/getCartProducts',
      cartCloud: 'order/cartCloud',
      totalProducts: 'order/totalProducts',
      totalCloud: 'order/totalCloud',
      orderSummary: 'order/summary',
      os: 'order/os',
      osPrice: 'order/osPrice',
      currentOs: 'auth/currentOs',
      licence: 'auth/userLicence',
      changeLicence: 'order/changeLicence',
      getPolicy: 'order/policy',
      discount: 'order/discount',
      discounts: 'order/discounts',
      selectedCloudPlan: 'order/cloudPlan',
      selectedCloudMonths: 'order/cloudMonths',
      cloudCartTotal: 'order/cloudCartTotal',
      discountRecommendation: 'order/discountRecommendation',
      allProducts: 'order/summaryProducts',
      totalOrderNet: 'order/totalNet',
      totalOrderGross: 'order/totalGross',
      client: 'auth/client',
      seasonalDiscount: 'order/seasonalDiscount',
      orderSource: 'order/orderSource',
      currentStep: 'order/currentStep',
      cloudNeverHave2024: 'auth/cloudNeverHave2024',
    }),
    osPriceGross() {
      return this.osPrice + this.osPrice * 0.23;
    },
    policy() {
      return this.getPolicy;
    },
    regulations() {
      return window.baseURL + 'REGULAMIN-ZAKUPU-SKP-W-SERWISIE-MOJE-KONTO.pdf';
    },
    baseurl() {
      return window.baseURL;
    },
    osRegulations() {
      return window.baseURL + 'REGULAMIN-OPIEKI-SERWISOWEJ-SKP.pdf';
    },
    ossPromotion() {
      if (this.program === 'skp') {
        return (
          window.baseURL +
          'SKP-REGULAMIN-PROMOCJI-0PLN-ZA-VAT-OSS-DLA-KLIENTOW-SKP.pdf'
        );
      } else {
        return (
          window.baseURL +
          'SAM-REGULAMIN-PROMOCJI-0PLN-ZA-VAT-OSS-DLA-KLIENTOW-SAM.pdf'
        );
      }
    },
    osDiscount25PromotionSKP() {
      let discountUsed = this.discounts.find((e) => {
        return e.id === 605;
      });
      if (discountUsed && !this.currentOs) {
        if (this.program === 'skp') {
          return window.baseURL + 'SKP-REGULAMIN-PROMOCJI-25PROCENT-NA-OS.pdf';
        }
      }
      return null;
    },
    osDiscount25PromotionSAM() {
      let discountUsed = this.discounts.find((e) => {
        return e.id === 609;
      });
      if (discountUsed && !this.currentOs) {
        if (this.program === 'sam') {
          return window.baseURL + 'SAM-REGULAMIN-PROMOCJI-25PROCENT-NA-OS.pdf';
        }
      }
      return null;
    },
    discountBlackWeek() {
      return this.discounts.find((e) => {
        return e.id === 616;
      });
    },
    discountCloudHalfYear() {
      return this.cartCloud.length >= 6 && this.cartCloud.length < 12;
    },
    discountCloudFullYear() {
      return this.cartCloud.length === 12;
    },
    discountText() {
      let that = this;
      let text = '';
      this.discounts.forEach((availableDiscount) => {
        if (
          availableDiscount.id === 621 &&
          this.program === 'skp' &&
          !this.currentOs
        ) {
          text += 'Udzielono RABATU 15% na Opiekę Serwisową';
        } else if (
          availableDiscount.conditions === 'os' &&
          !that.skpAccountantAdd &&
          !that.skpCompanyAdd &&
          availableDiscount.id !== 658
        ) {
          text += 'Udzielony RABAT ' + availableDiscount.name + '<br>';
        }

        if (availableDiscount.conditions === 'VAT OSS') {
          let vatOss = that.cartProducts.find((e) => {
            return e.label === 'VAT OSS';
          });

          if (vatOss && that.currentOs && vatOss.NETTO === 0) {
            text += 'Udzielony RABAT, moduł VAT-OSS otrzymujesz za darmo.<br>';
          }
        }
        if (availableDiscount.id === 610) {
          let courseSkp = that.cartProducts.find((e) => {
            return e.ID === 97;
          });
          if (courseSkp) {
            text +=
              'Udzielono RABATU na zakup Certyfikowanego Kursu Obsługi SKP<sup>®</sup> <br>';
          }
        }
        if (availableDiscount.id === 616) {
          text += 'Udzielono RABATU na Black Month -50%<br>';
        }
        if (availableDiscount.id === 607 && this.program === 'sam') {
          this.changeSKP = true;
          text += 'Udzielono RABATU ' + availableDiscount.name;
        }
      });

      if (this.discountRecommendation) {
        text +=
          'Udzielony RABAT za polecenie' +
          this.program.toUpperCase() +
          '<sup>®</sup>: <br>';
      }

      if (
        (this.isDiscount649 || this.isDiscount656_657) &&
        [72, 77].includes(this.selectedCloudPlan) &&
        12 - this.cartCloud.length ===
          new Date().getMonth() +
            (new Date().getDate() >= parseInt(this.monthEnding) ? 1 : 0) &&
        that.cartCloud.length > 0 &&
        that.cartCloud[0].net === 0
      ) {
        text += 'Udzielony RABAT 100% do zamówienia ' + this.header + '<br>';
      } else {
        if (this.discountCloudHalfYear) {
          if (
            this.isAccountant &&
            this.cloudNeverHave &&
            this.isDiscount622_623
          ) {
            text += 'Udzielony RABAT 35% do zamówienia ' + this.header + '<br>';
          } else {
            text += 'Udzielony RABAT 10% do zamówienia ' + this.header + '<br>';
          }
        }

        if (this.discountCloudFullYear) {
          if (
            this.isAccountant &&
            this.cloudNeverHave &&
            this.isDiscount622_623
          ) {
            text += 'Udzielony RABAT 50% do zamówienia ' + this.header + '<br>';
          } else {
            text += 'Udzielony RABAT 15% do zamówienia ' + this.header + '<br>';
          }
        }
      }

      if (this.isDiscount656_657) {
        text += 'Udzielony RABAT 100% Opieka Serwisowa 2025<br>';
      }

      return text;
    },
    header() {
      return this.isAccountant || this.skpAccountantAdd
        ? 'SKP24 Connect Biuro'
        : this.program === 'sam' && !this.skpCompanyAdd
        ? 'SAM<sup>®</sup> Firma w Chmurze'
        : 'SKP24 Connect Firma';
    },
    allProductsFiltered() {
      // let productsFiltered = this.allProducts;
      let productsFiltered = this.allProducts.filter(
        (row) => row.label !== 'Certyfikowany Kurs Obsługi SKP®'
      );
      if (this.changeSKP) {
        productsFiltered.push({
          gross: 0,
          label: 'Przejście na program SKP<sup>®</sup>',
          net: 0,
          quantity: 1,
          var: 23,
        });
      }
      return productsFiltered;
    },
    addedSkpTitle() {
      return this.skpAccountantAdd
        ? 'Przejście z programu SAM<sup>®</sup> na SKP<sup>®</sup> Biuro'
        : 'Przejście z programu SAM<sup>®</sup> na SKP<sup>®</sup> Firma';
    },
    isDiscount649() {
      return typeof this.cloudDiscount === 'object' &&
        this.cloudDiscount !== null
        ? this.cloudDiscount.id === 649
        : false;
    },
  },
  methods: {
    productSummary() {
      let products = [];

      if (this.program === 'skp' && !this.currentOs) {
        let osName = 'Opieka Serwisowa ' + this.year;
        let courseSkp = this.cartProducts.find((e) => {
          return e.ID === 97;
        });
        if (courseSkp) {
          osName =
            osName +
            ' wraz z bezpłatnym Kursem Obsługi SKP<sup>®</sup> Formsoft';
        }
        products.push({
          label: osName,
          net: this.osPrice,
          vat: 23,
          gross: this.osPriceGross,
          quantity: 1,
        });
      } else if (
        !this.currentOs &&
        !this.skpAdd &&
        !(
          localStorage.getItem('staffName') === 'formsoft' &&
          localStorage.getItem('staffId') === '0'
        )
      ) {
        let osName;
        if (this.program == 'sam') {
          osName = 'Bezpłatne przejście na SKP® z Opieką Serwisową ';
        } else {
          osName = 'Opieka Serwisowa ';
        }
        products.push({
          label: osName + this.year,
          net: this.osPrice,
          vat: 23,
          gross: this.osPriceGross,
          quantity: 1,
        });
      }

      if (this.cartCloud.length > 0) {
        this.cartCloud.forEach((item) => {
          products.push({
            label: item.label,
            quantity: item.quantity,
            net: item.net,
            vat: item.vat,
            gross: item.gross,
          });
        });
      }

      if (this.changeLicence) {
        products.push({
          label: 'Przeniesienie licencji',
          net: this.changeLicence.NETTO,
          vat: this.changeLicence.VAT,
          gross: this.changeLicence.BRUTTO,
        });
      }

      this.cartProducts.forEach((item) => {
        products.push({
          label: this.isTransferFromSamToSkp(item)
            ? this.addedSkpTitle
            : item.label
            ? item.label
            : item.OPIS,
          quantity: item.quantity,
          net: item.NETTO,
          vat: item.VAT,
          gross: item.BRUTTO,
        });
      });

      products.sort(function (a, b) {
        return (
          (a.label === 'Zryczałtowany koszt przesyłki Kurier / Poczta Polska') -
          (b.label === 'Zryczałtowany koszt przesyłki Kurier / Poczta Polska')
        );
      });

      this.$store.commit('order/setSummaryProducts', products);

      return products;
    },
    isTransferFromSamToSkp(item) {
      return (
        (item.UWAGI === 'N_SKP' && item.key !== 'O') ||
        (this.program === 'sam' &&
          (item.key === 'B1' || item.key === 'B2' || item.key === 'B3'))
      );
    },
    backStep() {
      if (this.orderSource === 'os') {
        this.$store.commit('order/changeStep', this.currentStep - 2);
      } else {
        this.$store.commit('order/decrementStep');
      }
    },
    forwardStep() {
      if (this.client && this.client.NIP !== null && this.client.NIP !== '') {
        this.errors = [];
        this.validateOrder();
        this.validatePolicy();
        if (this.errors.length === 0) {
          this.$store.commit('order/incrementStep');
        }
      } else {
        const h = this.$createElement;
        const msg = h('div', [
          h('p', { class: ['text-center'] }, [
            'Nie posiadasz nr NIP. Celem realizacji zamówienia skontaktuj się z BOK.',
          ]),
          h('p', { class: ['text-center', 'mb-1'] }, [
            'Pracujemy od poniedziałku do piątku',
          ]),
          h('p', { class: ['text-center', 'mb-1'] }, ['w godz. 8:00 - 16:00']),
          h('p', { class: ['text-center', 'mb-1'] }, ['tel. 76 854 79 58']),
          h('p', { class: ['text-center', 'mb-1'] }, ['skp@formsoft.pl']),
        ]);
        this.$bvModal.msgBoxOk([msg], {
          title: '',
          size: 'sm',
          buttonSize: 'sm',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        });
      }
    },
    cloudName(item) {
      return (
        helper.months[item.monthId] +
        ' - ' +
        this.cloudOptions[item.cloudId].text
      );
    },
    validateOrder() {
      if (this.allProducts.length === 0) {
        this.errors.push('Wybierz przynajmniej jeden produkt.');
      }
    },
    validatePolicy() {
      if (this.policy != 1) {
        this.errors.push('Zaakceptuj Regulamin zakupu i Politykę Prywatności.');
      }
    },
    commaFormat(value) {
      return Number(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    selectPolicy(value) {
      this.$store.commit('order/setPolicy', value);
    },
    runChat() {
      document.getElementById('chatbase-bubble-button').click();
    },
  },
};
</script>

<style scoped></style>
